import { RouteComponentProps } from "react-router-dom";
import { Product } from "../../services/ProductServices.dto";

export enum StepsTravel {
  DatosTomador = 1,
  DatosAsegurados = 2,
  ProteccionDatos = 3,
  MetodosPago = 4,
  DetallePrevioContratacion = 5,
}

export enum SimulationSteps {
  DatosRiesgo = 1,
  Resumen = 2,
}

export interface TravelHireMenuProps extends RouteComponentProps {
  codMediador: string;
  currentNumInsured: number;
  disableSubButtons: boolean;
  initialCurrentStep: StepsTravel;
  initialInsureds: {
    name: string;
    lastname1: string;
    lastname2: string;
  }[];
  insuredSaved: boolean;
  isHired: boolean;
  policy: Policy;
  policyType: string;
  selectedMediator: string | undefined;

  resumeOnHiring: () => void;
  downloadDocs: () => void;
  insuredOnAdd: (forceGo: boolean) => Promise<void>;
  insuredOnEdit: (index: number) => void;
  insuredOnRemove: (index: number) => void;
  insuredOnSave: () => void;
  payHiring: () => void;
  saveHiring: () => void;
  sendMailPrecontractualDocument: (showModal?: boolean) => void;
}

export interface TravelHireMenuState {
  currentStep: StepsTravel;
  insureds: {
    name: string;
    lastname1: string;
    lastname2: string;
  }[];
  showInsuredsOnDatosAsegurados: boolean;
}

export interface Policy {
  product: Product;
}
